import { Link } from "react-router-dom";
import UserActionSidebar from "./Element/usersidebar";
import { useState } from "react";

function RoleAndPermission() {
    const users = [
        { id: 1, name: "Harold Ge Magsayo", email: "brandon@email.com", role: "Master Admin", status: "Blocked" },
        { id: 2, name: "Adrian Anasco", email: "brandon@email.com", role: "Temporary Admin", status: "Active" },
        { id: 3, name: "Mery Grace Lofranco", email: "brandon@email.com", role: "Full Admin", status: "Pending" },
        { id: 4, name: "Brandon Jacob", email: "brandon@email.com", role: "Client", status: "Pending" },
        { id: 5, name: "Brandon Jacob", email: "brandon@email.com", role: "Employee", status: "Active" },
        { id: 6, name: "Brandon Jacob", email: "brandon@email.com", role: "Employee", status: "Active" },
        { id: 7, name: "Brandon Jacob", email: "brandon@email.com", role: "Employee", status: "Active" },
        { id: 8, name: "Brandon Jacob", email: "brandon@email.com", role: "Employee", status: "Active" },
        { id: 9, name: "Brandon Jacob", email: "brandon@email.com", role: "Employee", status: "Active" },
        { id: 10, name: "Brandon Jacob", email: "brandon@email.com", role: "Employee", status: "Active" },
    ];

    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 5;

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentUsers = users.slice(indexOfFirstRow, indexOfLastRow);

    const totalPages = Math.ceil(users.length / rowsPerPage);

    return (
        <>
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>Role and Permission</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item">User Management</li>
                            <li className="breadcrumb-item active">Role and Permission </li>
                        </ol>
                    </nav>
                </div>

                <section className="section dashboard">
                    <div className="row">
                        <div className="col-12">
                            <div className="card recent-sales overflow-auto">
                                <div className="card-body">
                                    {/* Search Area */}
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h5 className="card-title m-0">User List</h5>
                                        {/* Right side: Search + Add Button */}
                                        <div className="d-flex align-items-center gap-2">
                                            {/* Search */}
                                            <input
                                                type="text"
                                                className="form-control form-control-sm me-2"
                                                placeholder="Search user..."
                                                style={{ width: "200px" }}
                                            />
                                        </div>
                                    </div>
                                    {/* Table */}
                                    <table className="table datatable">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Role</th>
                                                <th>Status</th>
                                                <th className="text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentUsers.map((user) => (
                                                <tr key={user.id}>
                                                    <th>{user.id}</th>
                                                    <td>{user.name}</td>
                                                    <td className="text-primary">{user.email}</td>
                                                    <td>{user.role}</td>
                                                    <td>
                                                        <span className={`badge ${user.status === "Active"
                                                            ? "bg-success"
                                                            : user.status === "Blocked"
                                                                ? "bg-danger"
                                                                : "bg-warning"
                                                            }`}>
                                                            {user.status}
                                                        </span>
                                                    </td>

                                                    <td className="text-center">
                                                        <i
                                                            className="bi bi-arrow-right-short"
                                                            role="button"
                                                            data-bs-toggle="offcanvas"
                                                            data-bs-target="#userActionSidebar"
                                                            style={{ fontSize: "18px", cursor: "pointer" }}
                                                        ></i>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <nav className="mt-3">
                                        <ul className="pagination justify-content-end">

                                            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={() => setCurrentPage(currentPage - 1)}
                                                >
                                                    Previous
                                                </button>
                                            </li>
                                            {[...Array(totalPages)].map((_, index) => (
                                                <li
                                                    key={index}
                                                    className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                                                >
                                                    <button
                                                        className="page-link"
                                                        onClick={() => setCurrentPage(index + 1)}
                                                    >
                                                        {index + 1}
                                                    </button>
                                                </li>
                                            ))}
                                            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={() => setCurrentPage(currentPage + 1)}
                                                >
                                                    Next
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <UserActionSidebar
                user={{
                    name: "Adrian Anasco",
                    role: "Employee"
                }}
            />
        </>
    )
}

export default RoleAndPermission